// Shared helper for the app/game keyword search endpoint. Centralizing this
// keeps every search entry point (global search, app tracking, keyword
// tracking, category tracking, app scanner, market research, etc.) behaving
// the same way when a user pastes a URL instead of typing a keyword.

const URL_PATTERN = /^https?:\/\//i

export const KEYWORD_SEARCH_PATH = "/tracker/games/search"

export const isUrlSearchTerm = term => {
  if (!term) return false
  return URL_PATTERN.test(String(term).trim())
}

// Builds the query params for KEYWORD_SEARCH_PATH given a raw search term
// (keyword or URL) plus any extra params (platform, page, country, filters...).
// Auto-detects URLs so every existing search box gains URL search for free.
export const buildKeywordSearchParams = (term, extraParams = {}) => {
  const trimmed = String(term ?? "").trim()
  const params = { ...extraParams }
  if (isUrlSearchTerm(trimmed)) {
    params.is_url = true
    params.url = trimmed
  } else {
    params.keyword = trimmed
  }
  return params
}

// KEYWORD_SEARCH_PATH returns `image` per game instead of the old `image_url`,
// and omits fields the rest of the app doesn't ask for. Normalizing here keeps
// every existing render site (which reads game.image_url) working unchanged.
export const normalizeSearchGame = game => {
  if (!game || typeof game !== "object") return game
  return {
    ...game,
    image_url: game.image_url || game.image,
  }
}

export const normalizeSearchGames = games =>
  Array.isArray(games) ? games.map(normalizeSearchGame) : games
